import { replaceExpress } from './common'

function toFundList(input) {
  if (Array.isArray(input)) {
    return input
  }
  return Object.values(input)
}

function fillTerms(express, terms) {
  return replaceExpress(express, { '#': terms })
}

function convert(_fundItems, rule, terms) {
  const tempFundItems = toFundList(_fundItems)
  if (!rule || !Array.isArray(rule.map) || rule.map.length === 0) {
    return tempFundItems
  }
  const fundItems = JSON.parse(JSON.stringify(tempFundItems))
  const ret = []
  if (Array.isArray(fundItems) && fundItems.length > 1) {
    fundItems.forEach((item) => {
      let fundItem = item
      rule.map.forEach((mapping) => {
        if (typeof mapping === 'function') {
          fundItem = mapping(fundItem, rule, terms)
        }
      })
      ret.push(fundItem)
    })
  }
  return ret
}

function convertLine(line, fundItem, rule, terms) {
  if (typeof line === 'string') {
    return replaceExpress(line, { $: fundItem, '#': terms })
  }
  const newLine = {}
  Object.keys(line).forEach((key) => {
    const express = line[key]
    if (Array.isArray(express)) {
      newLine[key] = express.map((exp) => {
        return convertLine(exp, fundItem, rule, terms)
      })
    } else if (typeof express === 'object') {
      newLine[key] = convertLine(express, fundItem, rule, terms)
    } else if (typeof express === 'function') {
      newLine[key] = express(fundItem, rule, terms)
    } else {
      newLine[key] = replaceExpress(express, { $: fundItem, '#': terms })
    }
  })
  return newLine
}

function mergeDetailBy(input, rule, terms) /* istanbul ignore next */ {
  return convertLine(rule, input, rule, terms)
}

function mergeByRules(input, rule, terms) {
  return input.map((inputItem) => convertLine(rule, inputItem, rule, terms))
}

export { toFundList, convert, fillTerms, mergeDetailBy, mergeByRules, convertLine }
